import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLink, useT } from "@/lib/i18n";

const KEY = "his_cookie_consent";
export const hasAnalyticsConsent = () => localStorage.getItem(KEY) === "all";
export const openCookieSettings = () => window.dispatchEvent(new Event("his:cookie-settings"));

export const CookieBanner = () => {
  const t = useT();
  const link = useLink();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setOpen(true);
    const reopen = () => setOpen(true);
    window.addEventListener("his:cookie-settings", reopen);
    return () => window.removeEventListener("his:cookie-settings", reopen);
  }, []);

  const choose = (v) => {
    localStorage.setItem(KEY, v);
    setOpen(false);
  };

  if (!open) return null;
  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      className="fixed inset-x-3 bottom-3 z-[70] mx-auto flex max-w-3xl flex-col gap-3 rounded-2xl border border-forest/10 bg-ivory-card/95 p-4 shadow-2xl backdrop-blur-md sm:bottom-6 sm:flex-row sm:items-center sm:gap-6 sm:p-5"
    >
      <p className="text-[13px] leading-snug text-forest sm:text-sm">
        {t.cookie.text}{" "}
        <Link to={link("cookies")} className="underline underline-offset-4" data-testid="cookie-policy-link">{t.cookie.more}</Link>
      </p>
      <div className="flex shrink-0 gap-2">
        <button data-testid="cookie-accept-btn" onClick={() => choose("all")} className="btn btn-forest !px-4 !py-2.5 text-[13px] hover:!text-white">{t.cookie.accept}</button>
        <button data-testid="cookie-reject-btn" onClick={() => choose("essential")} className="btn btn-outline !px-4 !py-2.5 text-[13px]">{t.cookie.reject}</button>
      </div>
    </div>
  );
};
